import { createContext, useContext, useMemo } from 'react';

interface FeedbackContextValue {
  accountToken?: string;
  apiHost?: string;
  mfeVersion?: string;
  reDisplayAfterDays?: string;
  enabled?: boolean;
}

const FeedbackContext = createContext<FeedbackContextValue>({});

export function FeedbackProvider({
  accountToken,
  apiHost,
  mfeVersion,
  reDisplayAfterDays,
  enabled = true,
  children,
}: FeedbackContextValue & { children: React.ReactNode }) {
  const value = useMemo(
    () => ({ accountToken, apiHost, mfeVersion, reDisplayAfterDays, enabled }),
    [accountToken, apiHost, mfeVersion, reDisplayAfterDays, enabled],
  );

  return <FeedbackContext.Provider value={value}>{children}</FeedbackContext.Provider>;
}

export function useFeedbackConfig() {
  return useContext(FeedbackContext);
}
